import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/telao";
const getAuthorizationPin = () => {
  if (typeof window === "undefined") return "";
  return localStorage.getItem("tokenPin") ?? "";
};
// const controller = "/TelaoMdw";

/**
 * Classe de gerenciamento de chamadas da API de telão
 *
 * @class
 */
export default class TelaoApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  /**
   * Cria uma nova instância da classe TelaoApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */

  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
   * Lista tipos de senha
   * @param codTelao - Código do telão
   * @returns Lista de tipos de senha
   */
  async listarTipoSenha(codTelao: number) {
    try {
      const resp = await this.api(`${controller}/ListarTipoSenha`, {
        headers: {
          "Content-Type": "application/json",
          AuthorizationPin: getAuthorizationPin(),
        },
        method: "GET",
        params: {
          codTelao,
        },
      });
      return resp;
    } catch (error) {
      console.error("Erro ao listar tipos de senha:", error);
      throw error;
    }
  }

  /**
   * Lista Todos os Grupos de senha
   * @returns Lista de grupos de senha
   */

  async BuscarGruposSenhaCadastrados() {
    try {
      const resp = await this.api(
        `${controller}/BuscarGruposSenhaCadastrados`,
        {
          headers: {
            "Content-Type": "application/json",
            "AuthorizationPin": getAuthorizationPin(),
          },
          method: "GET",
        },
      );
      return resp;
    } catch (error) {
      console.error("Erro ao contar grupos de senha:", error);
      throw error;
    }
  }
}
